module.exports = {
	"multipleChoice": "multipleChoice",
	"multipleAnswer": "multipleAnswer",
	"multipleAnswerCombo": "multipleAnswerCombo",
	"number": "number",
	"text": "text",
	"height": "height",
	"weight": "weight",
	"range": "range",
	"yesNo": "yesNo"
};


//////////////////
// WEBPACK FOOTER
// ./src/components/questions/questionTypes.json
// module id = 48
// module chunks = 0